<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue'

import { useModalPopup } from '@/services/seoGlobalService'

const modalData = useModalPopup()

const isVisible = ref<boolean>(false)

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null
  return null
}

const setCookie = (name: string, value: string, days?: number) => {
  let cookieString = `${name}=${value}; path=/`
  if (days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    cookieString += `; expires=${expires}`
  }
  document.cookie = cookieString
}

const acceptDisclaimer = () => {
  document.body.style.overflow = ''

  setCookie('fsc', 'true') // Set a session cookie
  isVisible.value = false
}

const leavePage = () => {
  window.location.href = 'https://www.google.com/'
}

onMounted(() => {
  const cookieValue = getCookie('fsc')
  isVisible.value = (cookieValue === 'false')
  if (isVisible.value) {
    document.body.style.overflow = 'hidden'
  }
})

onUnmounted(() => {
  document.body.style.overflow = ''
})
</script>

<template>
  <div
    @click.prevent
    v-if="isVisible"
    class="fixed inset-0 z-[1000] w-full h-full bg-black bg-opacity-85"
  ></div>

  <div
    v-if="isVisible"
    class="fixed inset-0 top-[100px] px-[10px] pointer-events-none z-[3000] flex items-center justify-center w-full h-[85%] overflow-hidden"
  >
    <div
      class="bg-white lg:pb-20 rounded-[10px] shadow-lg w-full max-w-[1200px] lg:h-auto h-full flex flex-col items-center pb-20 relative overflow-auto popup-vector pointer-events-auto"
    >
      <h2 class="mb-10 lg:px-0 px-[10px] text-center lg:pt-20 h2-bold pt-[120px]">
        {{ modalData?.title }}
      </h2>
      <div
        class="mb-20 lg:px-0 px-[10px] t butter-wysiwyg max-w-[960px] w-full z-20 relative"
        v-html="modalData?.content"
      ></div>
      <div
        class="flex flex-col justify-center w-full lg:gap-5 gap-[10px] lg:flex-row px-[6px] relative z-30"
      >
        <button
          class="px-2 py-2 lg:py-4 lg:mr-2 border-2 text-red-150 button rounded w-full max-w-[470px]"
          @click="acceptDisclaimer"
        >
          {{ modalData?.left_button }}
        </button>

        <button
          class="px-[10px] py-2 text-white bg-red-150 rounded w-full max-w-[470px] button"
          @click="leavePage"
        >
          {{ modalData?.right_button }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media (min-width: 1200px) {
  .popup-vector::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('/assets/popup-vector.png');
    z-index: 10;
    opacity: 1;
  }
}
</style>
